import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b629c950")

_pushScopeId("data-v-b629c950")
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "display-flex" }
const _hoisted_3 = { style: {"flex":"1"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Clear Search")
const _hoisted_5 = { class: "scroll" }
const _hoisted_6 = {
  key: 2,
  class: "text-align-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("New Job")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_searchbar = _resolveComponent("f7-searchbar")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_badge = _resolveComponent("f7-badge")
  const _component_f7_segmented = _resolveComponent("f7-segmented")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_page = _resolveComponent("f7-page")

  return (_openBlock(), _createBlock(_component_f7_page, { name: "jobs" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_f7_link, {
            class: "menu-btn mobile-only",
            "icon-only": "",
            "icon-f7": "menu",
            "icon-size": "32",
            "panel-open": "left"
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_f7_searchbar, {
              id: "panel-search",
              placeholder: "Search by name or ID",
              "clear-button": false,
              "disable-button": false,
              "custom-search": true,
              value: _ctx.searchQuery,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _withDirectives(_createVNode(_component_f7_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(_ctx.activeTab.filter)))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.searchQuery.length > 0]
        ]),
        _withDirectives(_createVNode(_component_f7_segmented, {
          class: "tabs",
          strong: "",
          tag: "p"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createBlock(_component_f7_button, {
                key: tab.filter,
                onClick: ($event: any) => (_ctx.changeTab(tab.filter)),
                active: tab.filter === _ctx.activeTab.filter
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(tab.name) + " ", 1),
                  (
            !_ctx.appState.admin &&
            tab.filter === 'finalized' &&
            (tab.data?.length ?? 0 > 0)
          )
                    ? (_openBlock(), _createBlock(_component_f7_badge, {
                        key: 0,
                        color: "red",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(tab.data?.length), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onClick", "active"]))
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.searchQuery === '']
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("div", { class: "block-strong text-align-center" }, _toDisplayString(_ctx.activeTab.description), 513), [
            [_vShow, _ctx.searchQuery === '']
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_f7_list, {
                key: 0,
                "virtual-list": "",
                "no-hairlines": "",
                class: "skeleton-text skeleton-effect-wave no-margin",
                style: {"flex":"1"}
              }, {
                default: _withId(() => [
                  _createVNode(_component_f7_list_item, {
                    title: "Title and beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and even mOrE bEans",
                    footer: "Foooooooooooter"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and more beans",
                    footer: "Footer"
                  }),
                  _createVNode(_component_f7_list_item, {
                    title: "Title and no beans",
                    footer: "Footooer"
                  })
                ]),
                _: 1
              }))
            : (_ctx.results.length > 0)
              ? (_openBlock(), _createBlock(_component_f7_list, {
                  key: 1,
                  "virtual-list": "",
                  "no-hairlines": "",
                  class: "no-margin"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                      return (_openBlock(), _createBlock(_component_f7_list_item, {
                        title: result.title == '' ? 'Unnamed Job' : result.title,
                        footer: result.id,
                        key: result.id,
                        link: result.link,
                        style: 
              result.id === _ctx.appState.activeJob
                ? 'background-color: #303030'
                : null
            ,
                        view: ".view-main"
                      }, null, 8, ["title", "footer", "link", "style"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock("p", _hoisted_6, "Nothing found."))
        ]),
        _createVNode(_component_f7_button, {
          class: "new-job-btn",
          fill: "",
          href: "/jobs/new",
          view: ".view-main"
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})